var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_39_6142)" } }, [
        _c("path", {
          attrs: {
            d: "M5.91675 6C6.7124 6 7.47546 5.68393 8.03807 5.12132C8.60068 4.55871 8.91675 3.79565 8.91675 3C8.91675 2.20435 8.60068 1.44129 8.03807 0.87868C7.47546 0.316071 6.7124 0 5.91675 0C5.1211 0 4.35804 0.316071 3.79543 0.87868C3.23282 1.44129 2.91675 2.20435 2.91675 3C2.91675 3.79565 3.23282 4.55871 3.79543 5.12132C4.35804 5.68393 5.1211 6 5.91675 6ZM4.84565 7.125C2.53706 7.125 0.666748 8.99531 0.666748 11.3039C0.666748 11.6883 0.978467 12 1.36284 12H10.4707C10.855 12 11.1667 11.6883 11.1667 11.3039C11.1667 8.99531 9.29644 7.125 6.98784 7.125H4.84565Z",
            fill: "#717986",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_39_6142" } }, [
          _c("rect", { attrs: { width: "12", height: "12", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }